import * as React from 'react'
import dynamic from 'next/dynamic'

import {
  getADAChatContainer,
  isADAChatAvailable,
} from '@thg-commerce/enterprise-utils/src/ADAChat/ADAChat'

import {
  ADAChatContainer,
  ADAChatIndicator,
  ADAChatUnavailableMessage,
  ADAChatUnavailableMessageText,
} from './styles'

const ADAChatOutline = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/LiveChatOutline'),
)
const ADAChat = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/LiveChat'),
)
const SvgIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SvgIcon'),
)

import { i18n, useTheme } from '../../../..'
import { Content, LeftContent } from '../styles'

export interface ADAChatContentProps {
  alternateText?: boolean
  outline?: boolean
}
export const ADAChatContent = (props: ADAChatContentProps) => {
  const [isActive, setIsActive] = React.useState<boolean>(false)
  const [showMessage, setShowMessage] = React.useState<boolean>(false)

  React.useEffect(() => {
      setIsActive(isADAChatAvailable(document))
      isADAChatAvailable(document) && setShowMessage(false)
  }, [])

  const {
    icons: { chatOutline, chatFilled },
  } = useTheme()

  const triggerADAChat = () => {
    if (!isActive) {
      setShowMessage(!showMessage)
      return
    }
    setShowMessage(false)
    isActive && window?.adaEmbed && window.adaEmbed?.toggle()
  }
  const i18nText = {
    adaChat: i18n('myaccount.adachat.text'),
    adaChatUnavailable: i18n('account.adachat.unavailable'),
  }
  return (
    <ADAChatContainer
      type="button"
      onClick={triggerADAChat}
      onBlur={() => setShowMessage(false)}
      data-testid="ada-chat-bot"
      alternateText={props.alternateText}
    >
      <LeftContent>
        {chatOutline?.svgPath && chatFilled?.svgPath ? (
          props.outline ? (
            <SvgIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox={chatOutline.viewBox}
              width={chatOutline.width}
              height={chatOutline.height}
            >
              <path d={chatOutline.svgPath} fillRule="evenodd" />
            </SvgIcon>
          ) : (
            <SvgIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox={chatFilled.viewBox}
              width={chatFilled.width}
              height={chatFilled.height}
            >
              <path d={chatFilled.svgPath} fillRule="evenodd" />
            </SvgIcon>
          )
        ) : props.outline ? (
          <ADAChatOutline />
        ) : (
          <ADAChat />
        )}
      </LeftContent>
      <Content>
        <span>{i18nText.adaChat}</span>
        <ADAChatIndicator
          isActive={isActive}
          data-testid={`ada-chat-${isActive ? 'active' : 'inactive'}`}
        ></ADAChatIndicator>
        {showMessage && !isActive && (
          <ADAChatUnavailableMessage>
            <ADAChatUnavailableMessageText>
              {i18nText.adaChatUnavailable}
            </ADAChatUnavailableMessageText>
          </ADAChatUnavailableMessage>
        )}
      </Content>
    </ADAChatContainer>
  )
}
